$(function () {
	$('[data-scroller-target]').each(function() {
		var $dataScroller = $(this);
		$dataScroller.on('click', function (e) {
			e.preventDefault();
			$(window).trigger('scroller.scrolled');
			var $scrollerTarget = $('#' + $dataScroller.data('scrollerTarget'));
			$('html,body').animate({
				scrollTop: $scrollerTarget.offset().top
			});
		});
	});
});